import {
  browserSessionPersistence,
  GoogleAuthProvider,
  setPersistence,
  signInWithPopup,
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { toast } from "react-toastify";
import { auth, db } from "./index";

// Google Auth Provider
const googleAuthProvider = new GoogleAuthProvider();

// Function to trigger Google SignIn PopUp
const signInWithGoogle = () => {
  setPersistence(auth, browserSessionPersistence).then(() => {
    return signInWithPopup(auth, googleAuthProvider)
      .then(async (result) => {
        // Store user details as a document in firestore
        await setDoc(doc(db, "users", result.user.uid), {
          uid: result.user.uid,
          name: result.user.displayName,
          email: result.user.email,
          photoUrl: result.user.photoURL,
        });
        toast.success(`Logined as ${result.user.displayName}`);
      })
      .catch(() => toast.error("Unable to login"));
  });
};

// Function to trigger sign out
const logout = () => {
  auth.signOut().then(() => {
    toast.success("SignOut Successfully");
  });
};

export { signInWithGoogle, logout };
